import { cn } from '@/lib/cn';

/**
 * The ambient wash of the signed-in user's profile "flavor" — a viewport-fixed
 * layer at `z-index: -1`, so it sits above the solid `body` ground but behind all
 * page content. Render it once near the app root; the shells it shows through
 * must NOT paint their own opaque full-bleed background. The colour follows the
 * `--u-flavor*` vars set by `features/profile/flavor-theme.ts`.
 */
export function AppAura({ className }: { className?: string }) {
  return <div className={cn('app-aura', className)} aria-hidden />;
}
